import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelopeOpen, faLock, faUserCheck } from '@fortawesome/free-solid-svg-icons'
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { Zoom } from 'react-reveal';
import swal from 'sweetalert';

const Register = () => {
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const [customError, setCustomError] = useState('');

    const navigate = useNavigate();

    //Register From 
    const onSubmit = data => {
        fetch('https://one0m-backend2.onrender.com/auth/register', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then(result => {
                if (result?.success) {
                    swal('Register Successfully', 'Your account register successfully done', 'success');
                    setCustomError('');
                    reset();
                    navigate('/login');
                }

                if (result?.error?.includes('E11000 duplicate key error collection')) {
                    setCustomError('Already use this email!!');
                }
                console.log('result', result)

            })
    }

    return (
        <div className='container-fluid p-5' style={{ marginTop: '100px', fontFamily: 'Poppins' }}>
            <Zoom>
                <div className="register-account">
                    <div className="row">
                        <div className="col-lg-4 mx-auto cBorder shadow-lg pt-3 pb-3">
                            <div className="loginTitle text-center mb-3">
                                <h4 className='fw-bold'>Register Now!!</h4>
                            </div>
                            {/* Custom Error  */}

                            <p className='text-light text-center bg-danger mb-3 rounded'>{customError}</p>

                            <form onSubmit={handleSubmit(onSubmit)}>

                                <div className="row gy-2">
                                    <div className="col-lg-12">
                                        <div class="input-group mb-2">
                                            <span className="input-group-text btn btn-danger border border-danger" id="basic-addon1"><FontAwesomeIcon icon={faUserCheck} className='text-light' /></span>
                                            <input {...register("name", { required: true })} className='form-control' placeholder='Your Full Name' type='text' />
                                        </div>
                                        {errors.name && <span className='text-danger'>Full Name is required</span>}
                                    </div>
                                    <div className="col-lg-12">
                                        <div class="input-group mb-2">
                                            <span className="input-group-text btn btn-danger border border-danger" id="basic-addon1"><FontAwesomeIcon icon={faEnvelopeOpen} className='text-light' /></span>
                                            <input {...register("email", { required: true })} className='form-control' placeholder='Email address' type='email' />
                                        </div>
                                        {errors.email && <span className='text-danger'>Email is required</span>}
                                    </div>
                                    <div className="col-lg-12">
                                        <div class="input-group mb-2">
                                            <span className="input-group-text btn btn-danger border border-danger" id="basic-addon1"><FontAwesomeIcon icon={faLock} className='text-light' /></span>
                                            <input {...register("password", { required: true })} className='form-control' placeholder='Create new password' type='password' />
                                        </div>
                                        {errors.password && <span className='text-danger'>Password is required</span>}
                                    </div>
                                    <div className="col-lg-12">
                                        <input type="submit" className='d-block btn btn-danger w-100 border-0 text-light fw-bold rounded p-2' value='Register' />
                                    </div>
                                </div>
                            </form>
                            <p className='mt-4 text-secondary text-center'>Already have an account ?  <Link to='/login' className='fs-6 fw-bold'>Login</Link></p>
                        </div>
                    </div>

                </div>
            </Zoom>
        </div>
    );
};

export default Register;